import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

function Contact() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    servizio: '',
    messaggio: ''
  });

  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validazione privacy
    if (!privacyAccepted) {
      setStatus('❌ Devi accettare la Privacy Policy per continuare');
      return;
    }

    setStatus('Invio in corso...');

    // Genera token reCAPTCHA Enterprise in modo invisibile
    let recaptchaToken;
    try {
      await window.grecaptcha.enterprise.ready();
      recaptchaToken = await window.grecaptcha.enterprise.execute('6Ldzwl8sAAAAAPWCC0mDo3HMyY0aegHrGeHoIvoq', {action: 'CONTACT_FORM'});
    } catch (error) {
      console.error('Errore reCAPTCHA:', error);
      setStatus('❌ Errore di verifica. Riprova.');
      return;
    }

    try {
      const response = await fetch('/api_contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          recaptchaToken
        }),
      });

      const result = await response.json();

      if (result.status === 'success') {
        // Log di conferma in console per te
        console.log("Mail inviata con successo:", result.message);
        // UX per l'utente: piccolo feedback e poi redirect
        setStatus('✅ Messaggio inviato!');
        setTimeout(() => {
          navigate('/thank-you');
        }, 1500);
      } else {
        // Mostra l'errore solo se il server risponde "error"
        setStatus('❌ Errore: ' + result.message);
      }
    } catch (error) {
      console.error("Errore fetch:", error);
      setStatus('❌ Errore di connessione. Riprova tra poco.');
    }
  };

  return (
    <div className="contact-split">
      
      {/* COLONNA SINISTRA */}
      <div className="contact-info-side">
        <h1>Parliamo del tuo progetto</h1>
        <p className="subtitle" style={{textAlign: 'left', marginBottom: '0'}}>
          Hai un'idea in mente? Compila il form per un preventivo o una consulenza gratuita.<br /><br />
          Rispondo solitamente entro 24 ore lavorative.
        </p>

        <hr style={{
          border: '0',
          borderTop: '1px solid var(--border)',
          margin: '40px 0'
        }} />

        <div style={{ textAlign: 'center' }}>
          <p style={{ 
            marginBottom: '15px', 
            color: 'var(--text-sub)', 
            fontSize: '0.9rem',
            textTransform: 'uppercase',
            fontWeight: '600'
          }}>
            o invia direttamente una mail
          </p>

          <a 
            href="mailto:info@giovannirampazzo.com?subject=Richiesta%20Preventivo"
            className="btn-secondary"
            style={{
              borderColor: '#06D4E0',
              color: '#06D4E0',
              padding: '12px 30px',
              display: 'inline-flex'
            }}
          >
            ✉️ RICHIEDI PREVENTIVO
          </a>
        </div>
      </div>

      {/* COLONNA DESTRA */}
      <div className="contact-form-side">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nome">Nome o Azienda</label>
            <input
              id="nome"
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
              placeholder="Mario Rossi"
              aria-required="true"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="mario@email.com"
              aria-required="true"
            />
          </div>

          <div className="form-group">
            <label htmlFor="servizio">Di cosa hai bisogno?</label>
            <select
              id="servizio"
              name="servizio"
              value={formData.servizio}
              onChange={handleChange}
              required
              aria-required="true"
            >
              <option value="" disabled>Seleziona un servizio...</option>
              <option value="Sito Vetrina">Sito Vetrina (WordPress)</option>
              <option value="Ecommerce">E-commerce (WooCommerce)</option>
              <option value="WebApp">Web App Custom (React)</option>
              <option value="AppMobile">App Mobile (iOS/Android)</option>
              <option value="Altro">Altro / Consulenza</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="messaggio">Dettagli progetto</label>
            <textarea
              id="messaggio"
              name="messaggio"
              rows="4"
              value={formData.messaggio}
              onChange={handleChange}
              placeholder="Descrivi la tua idea..."
            ></textarea>
          </div>

          {/* Checkbox Privacy Policy */}
          <div className="form-group" style={{ marginBottom: '25px' }}>
            <label style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '10px',
              cursor: 'pointer',
              fontSize: '0.9rem',
              textTransform: 'none',
              letterSpacing: 'normal'
            }}>
              <input
                type="checkbox"
                checked={privacyAccepted}
                onChange={(e) => setPrivacyAccepted(e.target.checked)}
                style={{
                  marginTop: '3px',
                  width: '18px',
                  height: '18px',
                  minWidth: '18px',
                  minHeight: '18px',
                  cursor: 'pointer',
                  accentColor: 'var(--accent)',
                  flexShrink: 0
                }}
                required
              />
              <span style={{ color: 'var(--text-main)' }}>
                Ho letto e accetto la{' '}
                <Link to="/privacy" target="_blank" style={{ color: 'var(--accent)', textDecoration: 'underline' }}>
                  Privacy Policy
                </Link>
                {' '}*
              </span>
            </label>
          </div>

          <button type="submit" className="btn-primary full-width" style={{width: '100%'}}>
            Invia Richiesta
          </button>

          {/* Avviso reCAPTCHA obbligatorio quando badge è nascosto */}
          <p style={{
            fontSize: '0.75rem',
            color: 'var(--text-sub)',
            textAlign: 'center',
            marginTop: '15px',
            lineHeight: '1.5'
          }}>
            Questo sito è protetto da reCAPTCHA e si applicano le{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)', textDecoration: 'underline' }}>
              Privacy Policy
            </a>
            {' '}e i{' '}
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent)', textDecoration: 'underline' }}>
              Termini di Servizio
            </a>
            {' '}di Google.
          </p>

          {status && (
            <div className="status-msg" style={{
              marginTop: '20px',
              color: status.includes('✅') ? '#06D4E0' : '#ff4d4d',
              textAlign: 'center',
              fontWeight: 'bold'
            }}>
              {status}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default Contact;